import { formatAmountForDisplay, formatDate } from 'src/utils'
import * as types from './types'

export default {
  [types.COMPANY_ID](state) {
    return state.filters.companyId
  },
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      // filters
      accountId: state.filters.accountId,
      start_date: state.filters.startDate,
      end_date: state.filters.endDate,
      type: state.filters.type
    }
  },
  [types.ACCOUNT_STATEMENT_LIST](state) {
    return state.accountStatements.map((accountStatement) => {
      return {
        formattedExecutionDate: accountStatement.execution_date
          ? formatDate(accountStatement.execution_date, 'DD/MM/YYYY')
          : '-',
        formattedDate: accountStatement.date
          ? formatDate(accountStatement.date, 'DD/MM/YYYY')
          : '-',
        isin: accountStatement.isin ?? '-',
        type: accountStatement.type,
        formattedAmount: formatAmountForDisplay(
          accountStatement.amount,
          accountStatement.currency
        ),
        description: accountStatement.description
      }
    })
  }
}
